export const API_URL = "https://online-shop-backend.up.railway.app/api";
